import { SimpleForm, Toolbar, useGetList, useRecordContext, ValidateForm } from "react-admin";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import SaveGroupCertificationButton from "./SaveGroupCertificationButton";
import { validateEdit } from "./validations";
import { Alert, Skeleton } from "@mui/material";
import GroupCertificationEditInputs from "./GroupCertificationEditInputs";

const GroupCertificationEditFormGroup = () => {
  const record = useRecordContext();

  const {
    data: fetchedGroup,
    isLoading: isLoadingGroup,
    error: groupError,
  } = useGetList(SiteResourcesEnum.Groups, {
    sort: { field: "id", order: "ASC" },
    pagination: { page: 1, perPage: 1 },
    filter: {
      code: record?.group_code,
      type: record?.group_type,
    },
  });

  if (!isLoadingGroup && (groupError || !Array.isArray(fetchedGroup) || fetchedGroup.length === 0)) {
    return (
      <Alert severity="error" sx={{ mb: 2, width: "100%" }}>
        {"Could not retrieve associated group"}
      </Alert>
    );
  }

  const group = fetchedGroup?.[0];

  return (
    <SimpleForm
      toolbar={
        <Toolbar>
          {isLoadingGroup ? (
            <Skeleton variant="text" width="100%" height={40} />
          ) : (
            <SaveGroupCertificationButton fetchedGroup={group} />
          )}
        </Toolbar>
      }
      validate={validateEdit as ValidateForm}
    >
      <GroupCertificationEditInputs />
    </SimpleForm>
  );
};

export default GroupCertificationEditFormGroup;
